import React, {PropTypes} from 'react';
import cs from 'classnames';

class PortionSlider extends React.Component {
    constructor(props) {
        super(props);

        this.onButtonDown = this.onButtonDown.bind(this);
        this.onButtonUp = this.onButtonUp.bind(this);
    }

    onButtonUp() {
        const value = this.props.initial + (this.props.partial ? 0.5 : 1);
        if (!this.props.disabled) {
            this.props.onChange(value);
        }
    }

    onButtonDown() {
        const value = Math.max(0, this.props.initial - (this.props.partial ? 0.5 : 1));
        if (!this.props.disabled) {
            this.props.onChange(value);
        }
    }

    render() {
        const value = this.props.initial;
        const disabled = this.props.disabled;
        const style = {
            width: "30px",
            padding: "6px 0"
        };
        return (
            <div className="input-group bootstrap-touchspin">
                <span className="input-group-btn">
                    <button className={ cs("btn bootstrap-touchspin-down", {"btn-success": disabled !== 1}) } style={style}
                            onClick={this.onButtonDown.bind(this)}>&ndash;</button>
                </span>
                <span className="form-control bl0 br0 spinner2 text-center"
                      style={{ backgroundColor: value === 0.5 ?'yellow':'white',
                              width: "30px",
                              padding: "6px 0",
                              textAlign: "center"
                          }}>{value}</span>
                <span className="input-group-btn">
                    <button className={ cs("btn bootstrap-touchspin-up", {"btn-success": disabled !== 1}) } style={style}
                            onClick={this.onButtonUp.bind(this)}>+</button>
                </span>
            </div>
        );
    }
}

PortionSlider.propTypes = {
    partial: PropTypes.oneOfType([PropTypes.bool.isRequired, PropTypes.number.isRequired]),
    initial: PropTypes.number,
    onChange: PropTypes.func,
    disabled: PropTypes.bool.isRequired,
};

export default PortionSlider;



/** WEBPACK FOOTER **
 ** ./src/components/PortionSlider.js
 **/